import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type Command = Database['public']['Tables']['events']['Insert'];

async function postEvent(command: Command) {
  const { data, error } = await apiClient
    .from('events')
    .insert(command)
    .select('id')
    .single();

  if (error) {
    throw error
  }

  return data;
}

export function usePostEvent() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (variables: { command: Command, subTopicId: string }) => postEvent(variables.command),
    onSuccess: () => {
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.upcoming(currentSpace.id) });
      }
    },
  })
}
